/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A high precision floating point value represented as a string */
  BigFloat: { input: string; output: string; }
  /** An arbitrary size integer represented as a string */
  BigInt: { input: string; output: string; }
  /** An opaque string using for tracking a position in results during pagination */
  Cursor: { input: string; output: string; }
  /** A date without time information */
  Date: { input: string; output: string; }
  /** A date and time */
  Datetime: { input: string; output: string; }
  /** A Javascript Object Notation value serialized as a string */
  JSON: { input: string; output: string; }
  /** Any type not handled by the type system */
  Opaque: { input: unknown; output: unknown; }
  /** A time without date information */
  Time: { input: string; output: string; }
  /** A universally unique identifier */
  UUID: { input: string; output: string; }
};

export type AccessPoliciesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AccessPoliciesFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AccessPoliciesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AccessPoliciesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type AccessPoliciesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policyDocument?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AccessPoliciesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type AccessPoliciesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  policyDocument?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ActionTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ActionTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ActionTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ActionTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  color?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ActionTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionsFilter = {
  actionTypeId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ActionsFilter>>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  linkToUrl?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ActionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ActionsFilter>>;
  textPhoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ActionsInsertInput = {
  actionTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  linkToUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  textPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ActionsOrderBy = {
  actionTypeId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  linkToUrl?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  textPhoneNumber?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ActionsUpdateInput = {
  actionTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  linkToUrl?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  textPhoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdministratorsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AdministratorsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AdministratorsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AdministratorsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type AdministratorsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdministratorsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type AdministratorsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AliasTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AliasTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isUserEditable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AliasTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AliasTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type AliasTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUserEditable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AliasTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  isUserEditable?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type AliasTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUserEditable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AliasesFilter = {
  alias?: InputMaybe<StringFilter>;
  aliasTypeId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AliasesFilter>>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AliasesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AliasesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type AliasesInsertInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AliasesOrderBy = {
  alias?: InputMaybe<OrderByDirection>;
  aliasTypeId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type AliasesUpdateInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  aliasTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ApiKeysFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ApiKeysFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  encryptedSecret?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ApiKeysFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ApiKeysFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type ApiKeysInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  encryptedSecret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ApiKeysOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  encryptedSecret?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type ApiKeysUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  encryptedSecret?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AppEventTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AppEventTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AppEventTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AppEventTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type AppEventTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AppEventTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type AppEventTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AppEventsFilter = {
  actionId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AppEventsFilter>>;
  appEventTypeId?: InputMaybe<UuidFilter>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  eventId?: InputMaybe<UuidFilter>;
  eventUserId?: InputMaybe<UuidFilter>;
  groupId?: InputMaybe<UuidFilter>;
  groupMemberId?: InputMaybe<UuidFilter>;
  groupMemberPermissionsId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AppEventsFilter>;
  notificationId?: InputMaybe<UuidFilter>;
  novaId?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AppEventsFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  organizationMemberId?: InputMaybe<UuidFilter>;
  organizationMemberInvitationId?: InputMaybe<UuidFilter>;
  organizationTypeId?: InputMaybe<UuidFilter>;
  pageViewId?: InputMaybe<UuidFilter>;
  scheduleId?: InputMaybe<UuidFilter>;
  scheduleTaskId?: InputMaybe<UuidFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type AppEventsInsertInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  appEventTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberPermissionsId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notificationId?: InputMaybe<Scalars['UUID']['input']>;
  novaId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  pageViewId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleTaskId?: InputMaybe<Scalars['UUID']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AppEventsOrderBy = {
  actionId?: InputMaybe<OrderByDirection>;
  appEventTypeId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  eventId?: InputMaybe<OrderByDirection>;
  eventUserId?: InputMaybe<OrderByDirection>;
  groupId?: InputMaybe<OrderByDirection>;
  groupMemberId?: InputMaybe<OrderByDirection>;
  groupMemberPermissionsId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  notificationId?: InputMaybe<OrderByDirection>;
  novaId?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  organizationMemberId?: InputMaybe<OrderByDirection>;
  organizationMemberInvitationId?: InputMaybe<OrderByDirection>;
  organizationTypeId?: InputMaybe<OrderByDirection>;
  pageViewId?: InputMaybe<OrderByDirection>;
  scheduleId?: InputMaybe<OrderByDirection>;
  scheduleTaskId?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type AppEventsUpdateInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  appEventTypeId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  data?: InputMaybe<Scalars['JSON']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  eventUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberPermissionsId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notificationId?: InputMaybe<Scalars['UUID']['input']>;
  novaId?: InputMaybe<Scalars['UUID']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  pageViewId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleId?: InputMaybe<Scalars['UUID']['input']>;
  scheduleTaskId?: InputMaybe<Scalars['UUID']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AppSettingsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<AppSettingsFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<AppSettingsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<AppSettingsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  value?: InputMaybe<StringFilter>;
};

export type AppSettingsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type AppSettingsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  value?: InputMaybe<OrderByDirection>;
};

export type AppSettingsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "BigFloat" */
export type BigFloatFilter = {
  eq?: InputMaybe<Scalars['BigFloat']['input']>;
  gt?: InputMaybe<Scalars['BigFloat']['input']>;
  gte?: InputMaybe<Scalars['BigFloat']['input']>;
  in?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigFloat']['input']>;
  lte?: InputMaybe<Scalars['BigFloat']['input']>;
  neq?: InputMaybe<Scalars['BigFloat']['input']>;
};

/** Boolean expression comparing fields on type "BigFloatList" */
export type BigFloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigFloat']['input']>>;
};

/** Boolean expression comparing fields on type "BigInt" */
export type BigIntFilter = {
  eq?: InputMaybe<Scalars['BigInt']['input']>;
  gt?: InputMaybe<Scalars['BigInt']['input']>;
  gte?: InputMaybe<Scalars['BigInt']['input']>;
  in?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['BigInt']['input']>;
  lte?: InputMaybe<Scalars['BigInt']['input']>;
  neq?: InputMaybe<Scalars['BigInt']['input']>;
};

/** Boolean expression comparing fields on type "BigIntList" */
export type BigIntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  contains?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  eq?: InputMaybe<Array<Scalars['BigInt']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['BigInt']['input']>>;
};

/** Boolean expression comparing fields on type "Boolean" */
export type BooleanFilter = {
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Boolean expression comparing fields on type "BooleanList" */
export type BooleanListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  contains?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  eq?: InputMaybe<Array<Scalars['Boolean']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Boolean']['input']>>;
};

export type CompositeNovaTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CompositeNovaTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<CompositeNovaTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CompositeNovaTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type CompositeNovaTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CompositeNovaTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type CompositeNovaTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CompositeNovasFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<CompositeNovasFilter>>;
  arn?: InputMaybe<StringFilter>;
  compositeNovaTypeId?: InputMaybe<UuidFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<CompositeNovasFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<CompositeNovasFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type CompositeNovasInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  compositeNovaTypeId?: InputMaybe<Scalars['UUID']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type CompositeNovasOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  compositeNovaTypeId?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type CompositeNovasUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  compositeNovaTypeId?: InputMaybe<Scalars['UUID']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConstellationsFilter = {
  activeActionId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ConstellationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  defaultQrCodeNovaId?: InputMaybe<UuidFilter>;
  defaultWebLinkNovaId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isArchived?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ConstellationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ConstellationsFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  uid?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ConstellationsInsertInput = {
  activeActionId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  defaultQrCodeNovaId?: InputMaybe<Scalars['UUID']['input']>;
  defaultWebLinkNovaId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  uid?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ConstellationsOrderBy = {
  activeActionId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  color?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  defaultQrCodeNovaId?: InputMaybe<OrderByDirection>;
  defaultWebLinkNovaId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isArchived?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  uid?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ConstellationsUpdateInput = {
  activeActionId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  defaultQrCodeNovaId?: InputMaybe<Scalars['UUID']['input']>;
  defaultWebLinkNovaId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  uid?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "Date" */
export type DateFilter = {
  eq?: InputMaybe<Scalars['Date']['input']>;
  gt?: InputMaybe<Scalars['Date']['input']>;
  gte?: InputMaybe<Scalars['Date']['input']>;
  in?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Date']['input']>;
  lte?: InputMaybe<Scalars['Date']['input']>;
  neq?: InputMaybe<Scalars['Date']['input']>;
};

/** Boolean expression comparing fields on type "DateList" */
export type DateListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Date']['input']>>;
  contains?: InputMaybe<Array<Scalars['Date']['input']>>;
  eq?: InputMaybe<Array<Scalars['Date']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Date']['input']>>;
};

/** Boolean expression comparing fields on type "Datetime" */
export type DatetimeFilter = {
  eq?: InputMaybe<Scalars['Datetime']['input']>;
  gt?: InputMaybe<Scalars['Datetime']['input']>;
  gte?: InputMaybe<Scalars['Datetime']['input']>;
  in?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Datetime']['input']>;
  lte?: InputMaybe<Scalars['Datetime']['input']>;
  neq?: InputMaybe<Scalars['Datetime']['input']>;
};

/** Boolean expression comparing fields on type "DatetimeList" */
export type DatetimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  contains?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  eq?: InputMaybe<Array<Scalars['Datetime']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Datetime']['input']>>;
};

export type DemoConstellationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<DemoConstellationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  demoSessionId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<DemoConstellationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<DemoConstellationsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type DemoConstellationsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  demoSessionId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DemoConstellationsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  demoSessionId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type DemoConstellationsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  demoSessionId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DemoSessionsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<DemoSessionsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  expiresAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<DemoSessionsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<DemoSessionsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type DemoSessionsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type DemoSessionsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  expiresAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type DemoSessionsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EntitlementCodesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EntitlementCodesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EntitlementCodesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EntitlementCodesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
};

export type EntitlementCodesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type EntitlementCodesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
};

export type EntitlementCodesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
};

export type ErrorLogTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ErrorLogTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ErrorLogTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ErrorLogTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ErrorLogTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ErrorLogTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ErrorLogTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ErrorLogsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ErrorLogsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  errorLogTypeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isResolved?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ErrorLogsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ErrorLogsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type ErrorLogsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  errorLogTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ErrorLogsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  errorLogTypeId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  isResolved?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type ErrorLogsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  error?: InputMaybe<Scalars['JSON']['input']>;
  errorLogTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isResolved?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventHttpRequestsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EventHttpRequestsFilter>>;
  arn?: InputMaybe<StringFilter>;
  baseUrl?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  eventId?: InputMaybe<UuidFilter>;
  fresh?: InputMaybe<BooleanFilter>;
  headers?: InputMaybe<StringListFilter>;
  hostname?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  ip?: InputMaybe<StringFilter>;
  ips?: InputMaybe<StringListFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  method?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EventHttpRequestsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EventHttpRequestsFilter>>;
  originalUrl?: InputMaybe<StringFilter>;
  path?: InputMaybe<StringFilter>;
  protocol?: InputMaybe<StringFilter>;
  secure?: InputMaybe<BooleanFilter>;
  stale?: InputMaybe<BooleanFilter>;
  subdomains?: InputMaybe<StringListFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  url?: InputMaybe<StringFilter>;
  xhr?: InputMaybe<BooleanFilter>;
};

export type EventHttpRequestsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  cookies?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  headers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['JSON']['input']>;
  route?: InputMaybe<Scalars['JSON']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  signedCookies?: InputMaybe<Scalars['JSON']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  subdomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  xhr?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventHttpRequestsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  baseUrl?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  eventId?: InputMaybe<OrderByDirection>;
  fresh?: InputMaybe<OrderByDirection>;
  hostname?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  ip?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  method?: InputMaybe<OrderByDirection>;
  originalUrl?: InputMaybe<OrderByDirection>;
  path?: InputMaybe<OrderByDirection>;
  protocol?: InputMaybe<OrderByDirection>;
  secure?: InputMaybe<OrderByDirection>;
  stale?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  xhr?: InputMaybe<OrderByDirection>;
};

export type EventHttpRequestsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  baseUrl?: InputMaybe<Scalars['String']['input']>;
  body?: InputMaybe<Scalars['JSON']['input']>;
  cookies?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  fresh?: InputMaybe<Scalars['Boolean']['input']>;
  headers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hostname?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  ip?: InputMaybe<Scalars['String']['input']>;
  ips?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  method?: InputMaybe<Scalars['String']['input']>;
  originalUrl?: InputMaybe<Scalars['String']['input']>;
  params?: InputMaybe<Scalars['JSON']['input']>;
  path?: InputMaybe<Scalars['String']['input']>;
  protocol?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Scalars['JSON']['input']>;
  route?: InputMaybe<Scalars['JSON']['input']>;
  secure?: InputMaybe<Scalars['Boolean']['input']>;
  signedCookies?: InputMaybe<Scalars['JSON']['input']>;
  stale?: InputMaybe<Scalars['Boolean']['input']>;
  subdomains?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  xhr?: InputMaybe<Scalars['Boolean']['input']>;
};

export type EventLocationsFilter = {
  accuracyRadius?: InputMaybe<FloatFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EventLocationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  city?: InputMaybe<StringFilter>;
  continent?: InputMaybe<StringFilter>;
  country?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  eventId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isAnonymous?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  latitude?: InputMaybe<FloatFilter>;
  longitude?: InputMaybe<FloatFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EventLocationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EventLocationsFilter>>;
  postalCode?: InputMaybe<StringFilter>;
  state?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type EventLocationsInsertInput = {
  accuracyRadius?: InputMaybe<Scalars['Float']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  continent?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventLocationsOrderBy = {
  accuracyRadius?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  city?: InputMaybe<OrderByDirection>;
  continent?: InputMaybe<OrderByDirection>;
  country?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  eventId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isAnonymous?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  latitude?: InputMaybe<OrderByDirection>;
  longitude?: InputMaybe<OrderByDirection>;
  postalCode?: InputMaybe<OrderByDirection>;
  state?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type EventLocationsUpdateInput = {
  accuracyRadius?: InputMaybe<Scalars['Float']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  continent?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isAnonymous?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  longitude?: InputMaybe<Scalars['Float']['input']>;
  postalCode?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventTestTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EventTestTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isSelfAssertable?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EventTestTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EventTestTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type EventTestTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfAssertable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventTestTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  isSelfAssertable?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type EventTestTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isSelfAssertable?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventsFilter = {
  actionId?: InputMaybe<UuidFilter>;
  aliasId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<EventsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  eventTestTypeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<EventsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<EventsFilter>>;
  timestamp?: InputMaybe<DatetimeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type EventsInsertInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  aliasId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventTestTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type EventsOrderBy = {
  actionId?: InputMaybe<OrderByDirection>;
  aliasId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  eventTestTypeId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type EventsUpdateInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  aliasId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  eventTestTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FeedbackMessageTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<FeedbackMessageTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  description?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<FeedbackMessageTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<FeedbackMessageTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type FeedbackMessageTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FeedbackMessageTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  color?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  description?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type FeedbackMessageTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FeedbackMessagesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<FeedbackMessagesFilter>>;
  arn?: InputMaybe<StringFilter>;
  canContact?: InputMaybe<BooleanFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  feedbackMessageTypeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  message?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<FeedbackMessagesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<FeedbackMessagesFilter>>;
  pageViewId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type FeedbackMessagesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  canContact?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  feedbackMessageTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  pageViewId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type FeedbackMessagesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  canContact?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  feedbackMessageTypeId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  message?: InputMaybe<OrderByDirection>;
  pageViewId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type FeedbackMessagesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  canContact?: InputMaybe<Scalars['Boolean']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  feedbackMessageTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  message?: InputMaybe<Scalars['String']['input']>;
  pageViewId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export enum FilterIs {
  NotNull = 'NOT_NULL',
  Null = 'NULL'
}

/** Boolean expression comparing fields on type "Float" */
export type FloatFilter = {
  eq?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  neq?: InputMaybe<Scalars['Float']['input']>;
};

/** Boolean expression comparing fields on type "FloatList" */
export type FloatListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Float']['input']>>;
  contains?: InputMaybe<Array<Scalars['Float']['input']>>;
  eq?: InputMaybe<Array<Scalars['Float']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Float']['input']>>;
};

export type GroupConstellationLinksFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GroupConstellationLinksFilter>>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  groupId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GroupConstellationLinksFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GroupConstellationLinksFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type GroupConstellationLinksInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupConstellationLinksOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  groupId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type GroupConstellationLinksUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupMemberTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GroupMemberTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GroupMemberTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GroupMemberTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type GroupMemberTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupMemberTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type GroupMemberTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupMembersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GroupMembersFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  groupId?: InputMaybe<UuidFilter>;
  groupMemberTypeId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  memberOrganizationId?: InputMaybe<UuidFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GroupMembersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GroupMembersFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type GroupMembersInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  memberOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupMembersOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  groupId?: InputMaybe<OrderByDirection>;
  groupMemberTypeId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  memberOrganizationId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type GroupMembersUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  groupId?: InputMaybe<Scalars['UUID']['input']>;
  groupMemberTypeId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  memberOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<GroupsFilter>>;
  arn?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isArchived?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<GroupsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<GroupsFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  parentGroupId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type GroupsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  parentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type GroupsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  color?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isArchived?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  parentGroupId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type GroupsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isArchived?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  parentGroupId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "ID" */
export type IdFilter = {
  eq?: InputMaybe<Scalars['ID']['input']>;
};

export type IconsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<IconsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<IconsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<IconsFilter>>;
  prefix?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type IconsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  iconDefinition?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type IconsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  prefix?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type IconsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  iconDefinition?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  prefix?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "Int" */
export type IntFilter = {
  eq?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  neq?: InputMaybe<Scalars['Int']['input']>;
};

/** Boolean expression comparing fields on type "IntList" */
export type IntListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Int']['input']>>;
  contains?: InputMaybe<Array<Scalars['Int']['input']>>;
  eq?: InputMaybe<Array<Scalars['Int']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type MigrationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<MigrationsFilter>>;
  id?: InputMaybe<IntFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<MigrationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<MigrationsFilter>>;
  timestamp?: InputMaybe<BigIntFilter>;
};

export type MigrationsInsertInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
};

export type MigrationsOrderBy = {
  id?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
};

export type MigrationsUpdateInput = {
  name?: InputMaybe<Scalars['String']['input']>;
  timestamp?: InputMaybe<Scalars['BigInt']['input']>;
};

export type NotificationTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NotificationTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  icon?: InputMaybe<StringFilter>;
  iconColor?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NotificationTypesFilter>;
  objectName?: InputMaybe<StringFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NotificationTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type NotificationTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  iconColor?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  objectName?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type NotificationTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  iconColor?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  objectName?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NotificationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  dismissed?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NotificationsFilter>;
  notificationTypeId?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NotificationsFilter>>;
  organizationMemberInvitationId?: InputMaybe<UuidFilter>;
  read?: InputMaybe<BooleanFilter>;
  timestamp?: InputMaybe<DatetimeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type NotificationsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notificationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NotificationsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  dismissed?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  notificationTypeId?: InputMaybe<OrderByDirection>;
  organizationMemberInvitationId?: InputMaybe<OrderByDirection>;
  read?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type NotificationsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  dismissed?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  notificationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  read?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NovaDecorationImagesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NovaDecorationImagesFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NovaDecorationImagesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NovaDecorationImagesFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type NovaDecorationImagesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NovaDecorationImagesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  imageUrl?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type NovaDecorationImagesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  imageUrl?: InputMaybe<Scalars['String']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NovaTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NovaTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  embeddedLinkTemplate?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NovaTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NovaTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  verb?: InputMaybe<StringFilter>;
};

export type NovaTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
};

export type NovaTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  embeddedLinkTemplate?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  verb?: InputMaybe<OrderByDirection>;
};

export type NovaTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedLinkTemplate?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  verb?: InputMaybe<Scalars['String']['input']>;
};

export type NovasFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<NovasFilter>>;
  arn?: InputMaybe<StringFilter>;
  color?: InputMaybe<StringFilter>;
  compositeNovaId?: InputMaybe<UuidFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  embeddedAliasId?: InputMaybe<UuidFilter>;
  embeddedLink?: InputMaybe<StringFilter>;
  icon?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<NovasFilter>;
  novaDecorationImageId?: InputMaybe<UuidFilter>;
  novaTypeId?: InputMaybe<UuidFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<NovasFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type NovasInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compositeNovaId?: InputMaybe<Scalars['UUID']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedAliasId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedLink?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  novaDecorationImageId?: InputMaybe<Scalars['UUID']['input']>;
  novaTypeId?: InputMaybe<Scalars['UUID']['input']>;
  qrStyle?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type NovasOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  color?: InputMaybe<OrderByDirection>;
  compositeNovaId?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  embeddedAliasId?: InputMaybe<OrderByDirection>;
  embeddedLink?: InputMaybe<OrderByDirection>;
  icon?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  novaDecorationImageId?: InputMaybe<OrderByDirection>;
  novaTypeId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type NovasUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  color?: InputMaybe<Scalars['String']['input']>;
  compositeNovaId?: InputMaybe<Scalars['UUID']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedAliasId?: InputMaybe<Scalars['UUID']['input']>;
  embeddedLink?: InputMaybe<Scalars['String']['input']>;
  icon?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  novaDecorationImageId?: InputMaybe<Scalars['UUID']['input']>;
  novaTypeId?: InputMaybe<Scalars['UUID']['input']>;
  qrStyle?: InputMaybe<Scalars['JSON']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "Opaque" */
export type OpaqueFilter = {
  eq?: InputMaybe<Scalars['Opaque']['input']>;
  is?: InputMaybe<FilterIs>;
};

/** Defines a per-field sorting order */
export enum OrderByDirection {
  /** Ascending order, nulls first */
  AscNullsFirst = 'AscNullsFirst',
  /** Ascending order, nulls last */
  AscNullsLast = 'AscNullsLast',
  /** Descending order, nulls first */
  DescNullsFirst = 'DescNullsFirst',
  /** Descending order, nulls last */
  DescNullsLast = 'DescNullsLast'
}

export type OrganizationMemberInvitationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OrganizationMemberInvitationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  declined?: InputMaybe<BooleanFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  invitedByUserId?: InputMaybe<UuidFilter>;
  invitedToOrganizationId?: InputMaybe<UuidFilter>;
  invitedUserEmailAddress?: InputMaybe<StringFilter>;
  invitedUserId?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OrganizationMemberInvitationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OrganizationMemberInvitationsFilter>>;
  organizationMemberRoleId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type OrganizationMemberInvitationsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  invitedToOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  invitedUserEmailAddress?: InputMaybe<Scalars['String']['input']>;
  invitedUserId?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationMemberRoleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMemberInvitationsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  declined?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  invitedByUserId?: InputMaybe<OrderByDirection>;
  invitedToOrganizationId?: InputMaybe<OrderByDirection>;
  invitedUserEmailAddress?: InputMaybe<OrderByDirection>;
  invitedUserId?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  organizationMemberRoleId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type OrganizationMemberInvitationsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  declined?: InputMaybe<Scalars['Boolean']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  invitedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  invitedToOrganizationId?: InputMaybe<Scalars['UUID']['input']>;
  invitedUserEmailAddress?: InputMaybe<Scalars['String']['input']>;
  invitedUserId?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationMemberRoleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMemberRolesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OrganizationMemberRolesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OrganizationMemberRolesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OrganizationMemberRolesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type OrganizationMemberRolesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  dynamicAccessPolicyTemplate?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMemberRolesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type OrganizationMemberRolesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  dynamicAccessPolicyTemplate?: InputMaybe<Scalars['JSON']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMembersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OrganizationMembersFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OrganizationMembersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OrganizationMembersFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  organizationMemberInvitationId?: InputMaybe<UuidFilter>;
  organizationMemberRoleId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type OrganizationMembersInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberRoleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationMembersOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  organizationMemberInvitationId?: InputMaybe<OrderByDirection>;
  organizationMemberRoleId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type OrganizationMembersUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberInvitationId?: InputMaybe<Scalars['UUID']['input']>;
  organizationMemberRoleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OrganizationTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OrganizationTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OrganizationTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type OrganizationTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type OrganizationTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<OrganizationsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<OrganizationsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<OrganizationsFilter>>;
  organizationTypeId?: InputMaybe<UuidFilter>;
  ownerUserId?: InputMaybe<UuidFilter>;
  slug?: InputMaybe<StringFilter>;
  stripeCustomerId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type OrganizationsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type OrganizationsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  organizationTypeId?: InputMaybe<OrderByDirection>;
  ownerUserId?: InputMaybe<OrderByDirection>;
  slug?: InputMaybe<OrderByDirection>;
  stripeCustomerId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type OrganizationsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationTypeId?: InputMaybe<Scalars['UUID']['input']>;
  ownerUserId?: InputMaybe<Scalars['UUID']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  stripeCustomerId?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PageViewsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PageViewsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<PageViewsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PageViewsFilter>>;
  timestamp?: InputMaybe<DatetimeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  url?: InputMaybe<StringFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type PageViewsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PageViewsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  timestamp?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  url?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type PageViewsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  timestamp?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PasswordResetTokensFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<PasswordResetTokensFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  expiresAt?: InputMaybe<DatetimeFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  isUsed?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<PasswordResetTokensFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<PasswordResetTokensFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type PasswordResetTokensInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type PasswordResetTokensOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  expiresAt?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  isUsed?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type PasswordResetTokensUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  expiresAt?: InputMaybe<Scalars['Datetime']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  isUsed?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScheduleTasksFilter = {
  actionId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ScheduleTasksFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  cronSchedule?: InputMaybe<StringFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ScheduleTasksFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ScheduleTasksFilter>>;
  scheduleId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ScheduleTasksInsertInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScheduleTasksOrderBy = {
  actionId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  cronSchedule?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  scheduleId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ScheduleTasksUpdateInput = {
  actionId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  cronSchedule?: InputMaybe<Scalars['String']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  scheduleId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScheduleTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ScheduleTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  enabled?: InputMaybe<BooleanFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ScheduleTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ScheduleTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ScheduleTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ScheduleTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  enabled?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ScheduleTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  enabled?: InputMaybe<Scalars['Boolean']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SchedulesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<SchedulesFilter>>;
  arn?: InputMaybe<StringFilter>;
  constellationId?: InputMaybe<UuidFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isActive?: InputMaybe<BooleanFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<SchedulesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<SchedulesFilter>>;
  scheduleTypeId?: InputMaybe<UuidFilter>;
  timeZone?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type SchedulesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleTypeId?: InputMaybe<Scalars['UUID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type SchedulesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  constellationId?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isActive?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  scheduleTypeId?: InputMaybe<OrderByDirection>;
  timeZone?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type SchedulesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  constellationId?: InputMaybe<Scalars['UUID']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  scheduleTypeId?: InputMaybe<Scalars['UUID']['input']>;
  timeZone?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogStatusesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ServiceRunLogStatusesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ServiceRunLogStatusesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ServiceRunLogStatusesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ServiceRunLogStatusesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogStatusesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ServiceRunLogStatusesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogTypesFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ServiceRunLogTypesFilter>>;
  arn?: InputMaybe<StringFilter>;
  code?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ServiceRunLogTypesFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ServiceRunLogTypesFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ServiceRunLogTypesInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogTypesOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  code?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ServiceRunLogTypesUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  code?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<ServiceRunLogsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  endTime?: InputMaybe<DatetimeFilter>;
  errorLogId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<ServiceRunLogsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<ServiceRunLogsFilter>>;
  serviceRunLogStatusId?: InputMaybe<UuidFilter>;
  serviceRunLogTypeId?: InputMaybe<UuidFilter>;
  startTime?: InputMaybe<DatetimeFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type ServiceRunLogsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  errorLogId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  serviceRunLogStatusId?: InputMaybe<Scalars['UUID']['input']>;
  serviceRunLogTypeId?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type ServiceRunLogsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  endTime?: InputMaybe<OrderByDirection>;
  errorLogId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  serviceRunLogStatusId?: InputMaybe<OrderByDirection>;
  serviceRunLogTypeId?: InputMaybe<OrderByDirection>;
  startTime?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type ServiceRunLogsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  context?: InputMaybe<Scalars['JSON']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  endTime?: InputMaybe<Scalars['Datetime']['input']>;
  errorLogId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  serviceRunLogStatusId?: InputMaybe<Scalars['UUID']['input']>;
  serviceRunLogTypeId?: InputMaybe<Scalars['UUID']['input']>;
  startTime?: InputMaybe<Scalars['Datetime']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "String" */
export type StringFilter = {
  eq?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  ilike?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<Scalars['String']['input']>>;
  iregex?: InputMaybe<Scalars['String']['input']>;
  is?: InputMaybe<FilterIs>;
  like?: InputMaybe<Scalars['String']['input']>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  neq?: InputMaybe<Scalars['String']['input']>;
  regex?: InputMaybe<Scalars['String']['input']>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

/** Boolean expression comparing fields on type "StringList" */
export type StringListFilter = {
  containedBy?: InputMaybe<Array<Scalars['String']['input']>>;
  contains?: InputMaybe<Array<Scalars['String']['input']>>;
  eq?: InputMaybe<Array<Scalars['String']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Boolean expression comparing fields on type "Time" */
export type TimeFilter = {
  eq?: InputMaybe<Scalars['Time']['input']>;
  gt?: InputMaybe<Scalars['Time']['input']>;
  gte?: InputMaybe<Scalars['Time']['input']>;
  in?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  lt?: InputMaybe<Scalars['Time']['input']>;
  lte?: InputMaybe<Scalars['Time']['input']>;
  neq?: InputMaybe<Scalars['Time']['input']>;
};

/** Boolean expression comparing fields on type "TimeList" */
export type TimeListFilter = {
  containedBy?: InputMaybe<Array<Scalars['Time']['input']>>;
  contains?: InputMaybe<Array<Scalars['Time']['input']>>;
  eq?: InputMaybe<Array<Scalars['Time']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['Time']['input']>>;
};

/** Boolean expression comparing fields on type "UUID" */
export type UuidFilter = {
  eq?: InputMaybe<Scalars['UUID']['input']>;
  in?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  neq?: InputMaybe<Scalars['UUID']['input']>;
};

/** Boolean expression comparing fields on type "UUIDList" */
export type UuidListFilter = {
  containedBy?: InputMaybe<Array<Scalars['UUID']['input']>>;
  contains?: InputMaybe<Array<Scalars['UUID']['input']>>;
  eq?: InputMaybe<Array<Scalars['UUID']['input']>>;
  is?: InputMaybe<FilterIs>;
  overlaps?: InputMaybe<Array<Scalars['UUID']['input']>>;
};

export type UserAccessPolicyAttachmentsFilter = {
  accessPolicyId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UserAccessPolicyAttachmentsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UserAccessPolicyAttachmentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UserAccessPolicyAttachmentsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserAccessPolicyAttachmentsInsertInput = {
  accessPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserAccessPolicyAttachmentsOrderBy = {
  accessPolicyId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type UserAccessPolicyAttachmentsUpdateInput = {
  accessPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupAccessPolicyAttachmentsFilter = {
  accessPolicyId?: InputMaybe<UuidFilter>;
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UserGroupAccessPolicyAttachmentsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UserGroupAccessPolicyAttachmentsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UserGroupAccessPolicyAttachmentsFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
};

export type UserGroupAccessPolicyAttachmentsInsertInput = {
  accessPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupAccessPolicyAttachmentsOrderBy = {
  accessPolicyId?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userGroupId?: InputMaybe<OrderByDirection>;
};

export type UserGroupAccessPolicyAttachmentsUpdateInput = {
  accessPolicyId?: InputMaybe<Scalars['UUID']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupMembersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UserGroupMembersFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UserGroupMembersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UserGroupMembersFilter>>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
  userGroupId?: InputMaybe<UuidFilter>;
  userId?: InputMaybe<UuidFilter>;
};

export type UserGroupMembersInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupMembersOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
  userGroupId?: InputMaybe<OrderByDirection>;
  userId?: InputMaybe<OrderByDirection>;
};

export type UserGroupMembersUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  userGroupId?: InputMaybe<Scalars['UUID']['input']>;
  userId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupsFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UserGroupsFilter>>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  name?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UserGroupsFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UserGroupsFilter>>;
  organizationId?: InputMaybe<UuidFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type UserGroupsInsertInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UserGroupsOrderBy = {
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  name?: InputMaybe<OrderByDirection>;
  organizationId?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type UserGroupsUpdateInput = {
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  organizationId?: InputMaybe<Scalars['UUID']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UsersFilter = {
  /** Returns true only if all its inner filters are true, otherwise returns false */
  and?: InputMaybe<Array<UsersFilter>>;
  appVersion?: InputMaybe<StringFilter>;
  appVersionSeenAt?: InputMaybe<DatetimeFilter>;
  arn?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DatetimeFilter>;
  createdByUserId?: InputMaybe<UuidFilter>;
  deletedAt?: InputMaybe<DatetimeFilter>;
  deletedByUserId?: InputMaybe<UuidFilter>;
  emailAddress?: InputMaybe<StringFilter>;
  firstName?: InputMaybe<StringFilter>;
  id?: InputMaybe<UuidFilter>;
  isDeleted?: InputMaybe<BooleanFilter>;
  lastName?: InputMaybe<StringFilter>;
  nodeId?: InputMaybe<IdFilter>;
  /** Negates a filter */
  not?: InputMaybe<UsersFilter>;
  /** Returns true if at least one of its inner filters is true, otherwise returns false */
  or?: InputMaybe<Array<UsersFilter>>;
  phoneNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DatetimeFilter>;
  updatedByUserId?: InputMaybe<UuidFilter>;
};

export type UsersInsertInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  appVersionSeenAt?: InputMaybe<Scalars['Datetime']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type UsersOrderBy = {
  appVersion?: InputMaybe<OrderByDirection>;
  appVersionSeenAt?: InputMaybe<OrderByDirection>;
  arn?: InputMaybe<OrderByDirection>;
  createdAt?: InputMaybe<OrderByDirection>;
  createdByUserId?: InputMaybe<OrderByDirection>;
  deletedAt?: InputMaybe<OrderByDirection>;
  deletedByUserId?: InputMaybe<OrderByDirection>;
  emailAddress?: InputMaybe<OrderByDirection>;
  firstName?: InputMaybe<OrderByDirection>;
  id?: InputMaybe<OrderByDirection>;
  isDeleted?: InputMaybe<OrderByDirection>;
  lastName?: InputMaybe<OrderByDirection>;
  phoneNumber?: InputMaybe<OrderByDirection>;
  updatedAt?: InputMaybe<OrderByDirection>;
  updatedByUserId?: InputMaybe<OrderByDirection>;
};

export type UsersUpdateInput = {
  appVersion?: InputMaybe<Scalars['String']['input']>;
  appVersionSeenAt?: InputMaybe<Scalars['Datetime']['input']>;
  arn?: InputMaybe<Scalars['String']['input']>;
  createdAt?: InputMaybe<Scalars['Datetime']['input']>;
  createdByUserId?: InputMaybe<Scalars['UUID']['input']>;
  deletedAt?: InputMaybe<Scalars['Datetime']['input']>;
  deletedByUserId?: InputMaybe<Scalars['UUID']['input']>;
  emailAddress?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  id?: InputMaybe<Scalars['UUID']['input']>;
  isDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  updatedAt?: InputMaybe<Scalars['Datetime']['input']>;
  updatedByUserId?: InputMaybe<Scalars['UUID']['input']>;
};

export type AdministratorSelfQueryVariables = Exact<{
  userId: string;
}>;


export type AdministratorSelfQuery = { administratorsCollection: { edges: Array<{ node: { id: string } }> } };

export type AdminOrganizationsQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
  pattern: string;
}>;


export type AdminOrganizationsQuery = { organizationsCollection: { edges: Array<{ node: { id: string, name: string, slug: string, createdAt: string, organizationType: { name: string } | null, organizationMembersCollection: { edges: Array<{ node: { id: string } }> } | null, constellationsCollection: { edges: Array<{ node: { id: string } }> } | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type AdminAppVersionsQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
}>;


export type AdminAppVersionsQuery = { usersCollection: { edges: Array<{ node: { id: string, emailAddress: string | null, firstName: string | null, lastName: string | null, appVersion: string | null, appVersionSeenAt: string | null } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } };

export type ActionFieldsFragment = { id: string, name: string, linkToUrl: string | null, textPhoneNumber: string | null, actionType: { code: string } | null };

export type AliasFieldsFragment = { id: string, alias: string, aliasType: { code: string, isUserEditable: boolean | null } | null };

export type DesignFieldsFragment = { id: string, name: string, color: string | null, qrStyle: string | null, embeddedLink: string | null, embeddedAliasId: string | null, novaType: { code: string } | null, novaDecorationImage: { imageUrl: string | null } | null };

export type ScheduleFieldsFragment = { id: string, name: string, isActive: boolean | null, timeZone: string | null, scheduleType: { code: string } | null, scheduleTasksCollection: { edges: Array<{ node: { id: string, cronSchedule: string | null, actionId: string | null } }> } | null };

export type QrCodeFieldsFragment = { id: string, name: string, color: string, icon: string | null, isArchived: boolean, activeActionId: string | null, defaultQrCodeNovaId: string | null, defaultWebLinkNovaId: string | null, createdAt: string, updatedByUser: { firstName: string | null, lastName: string | null } | null, actionsCollection: { edges: Array<{ node: { id: string, name: string, linkToUrl: string | null, textPhoneNumber: string | null, actionType: { code: string } | null } }> } | null, aliasesCollection: { edges: Array<{ node: { id: string, alias: string, aliasType: { code: string, isUserEditable: boolean | null } | null } }> } | null, novasCollection: { edges: Array<{ node: { id: string, name: string, color: string | null, qrStyle: string | null, embeddedLink: string | null, embeddedAliasId: string | null, novaType: { code: string } | null, novaDecorationImage: { imageUrl: string | null } | null } }> } | null, groupConstellationLinksCollection: { edges: Array<{ node: { groupId: string | null } }> } | null };

export type GroupFieldsFragment = { id: string, name: string, color: string, icon: string | null, parentGroupId: string | null };

export type ActionTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ActionTypesQuery = { actionTypesCollection: { edges: Array<{ node: { id: string, code: string, name: string } }> } };

export type FeedbackMessageTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type FeedbackMessageTypesQuery = { feedbackMessageTypesCollection: { edges: Array<{ node: { id: string, code: string, name: string, description: string | null, color: string | null } }> } };

export type OrganizationMemberRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type OrganizationMemberRolesQuery = { organizationMemberRolesCollection: { edges: Array<{ node: { id: string, code: string, name: string } }> } };

export type ScheduleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type ScheduleTypesQuery = { scheduleTypesCollection: { edges: Array<{ node: { id: string, code: string, name: string, enabled: boolean } }> } };

export type OrganizationMembersQueryVariables = Exact<{
  organizationId: string;
}>;


export type OrganizationMembersQuery = { organizationMembersCollection: { edges: Array<{ node: { id: string, createdAt: string, organizationMemberRole: { code: string } | null, user: { id: string, firstName: string | null, lastName: string | null, emailAddress: string | null } | null } }> }, organizationMemberInvitationsCollection: { edges: Array<{ node: { id: string, createdAt: string, invitedUserEmailAddress: string | null, organizationMemberRole: { code: string } | null, organizationMembersCollection: { edges: Array<{ node: { id: string } }> } | null } }> } };

export type NotificationsQueryVariables = Exact<{
  userId: string;
}>;


export type NotificationsQuery = { notificationsCollection: { edges: Array<{ node: { id: string, read: boolean | null, dismissed: boolean | null, timestamp: string | null, createdAt: string, notificationType: { code: string, name: string } | null, organizationMemberInvitation: { id: string, declined: boolean | null, invitedUserEmailAddress: string | null, invitedToOrganization: { id: string, name: string, slug: string } | null, invitedByUser: { firstName: string | null, lastName: string | null, emailAddress: string | null } | null, organizationMemberRole: { code: string, name: string } | null } | null } }> } };

export type OrganizationBySlugQueryVariables = Exact<{
  slug: string;
}>;


export type OrganizationBySlugQuery = { organizationsCollection: { edges: Array<{ node: { id: string, name: string, slug: string, organizationType: { code: string, name: string } | null, organizationMembersCollection: { edges: Array<{ node: { id: string } }> } | null } }> } };

export type OrganizationSlugsQueryVariables = Exact<{
  ids: Array<string> | string;
}>;


export type OrganizationSlugsQuery = { organizationsCollection: { edges: Array<{ node: { id: string, slug: string, name: string } }> } };

export type OrganizationQrCodesQueryVariables = Exact<{
  organizationId: string;
}>;


export type OrganizationQrCodesQuery = { constellationsCollection: { edges: Array<{ node: { id: string, name: string, color: string, icon: string | null, isArchived: boolean, activeActionId: string | null, defaultQrCodeNovaId: string | null, defaultWebLinkNovaId: string | null, createdAt: string, updatedByUser: { firstName: string | null, lastName: string | null } | null, actionsCollection: { edges: Array<{ node: { id: string, name: string, linkToUrl: string | null, textPhoneNumber: string | null, actionType: { code: string } | null } }> } | null, aliasesCollection: { edges: Array<{ node: { id: string, alias: string, aliasType: { code: string, isUserEditable: boolean | null } | null } }> } | null, novasCollection: { edges: Array<{ node: { id: string, name: string, color: string | null, qrStyle: string | null, embeddedLink: string | null, embeddedAliasId: string | null, novaType: { code: string } | null, novaDecorationImage: { imageUrl: string | null } | null } }> } | null, groupConstellationLinksCollection: { edges: Array<{ node: { groupId: string | null } }> } | null } }>, pageInfo: { hasNextPage: boolean } } };

export type OrganizationGroupsQueryVariables = Exact<{
  organizationId: string;
}>;


export type OrganizationGroupsQuery = { groupsCollection: { edges: Array<{ node: { id: string, name: string, color: string, icon: string | null, parentGroupId: string | null } }> } };

export type QrCodeQueryVariables = Exact<{
  constellationId: string;
}>;


export type QrCodeQuery = { constellationsCollection: { edges: Array<{ node: { id: string, name: string, color: string, icon: string | null, isArchived: boolean, activeActionId: string | null, defaultQrCodeNovaId: string | null, defaultWebLinkNovaId: string | null, createdAt: string, schedulesCollection: { edges: Array<{ node: { id: string, name: string, isActive: boolean | null, timeZone: string | null, scheduleType: { code: string } | null, scheduleTasksCollection: { edges: Array<{ node: { id: string, cronSchedule: string | null, actionId: string | null } }> } | null } }> } | null, updatedByUser: { firstName: string | null, lastName: string | null } | null, actionsCollection: { edges: Array<{ node: { id: string, name: string, linkToUrl: string | null, textPhoneNumber: string | null, actionType: { code: string } | null } }> } | null, aliasesCollection: { edges: Array<{ node: { id: string, alias: string, aliasType: { code: string, isUserEditable: boolean | null } | null } }> } | null, novasCollection: { edges: Array<{ node: { id: string, name: string, color: string | null, qrStyle: string | null, embeddedLink: string | null, embeddedAliasId: string | null, novaType: { code: string } | null, novaDecorationImage: { imageUrl: string | null } | null } }> } | null, groupConstellationLinksCollection: { edges: Array<{ node: { groupId: string | null } }> } | null } }> } };

export type SessionQueryVariables = Exact<{
  userId: string;
}>;


export type SessionQuery = { usersCollection: { edges: Array<{ node: { id: string, firstName: string | null, lastName: string | null, emailAddress: string | null } }> }, organizationMembersCollection: { edges: Array<{ node: { id: string, organizationMemberRole: { code: string } | null, organization: { id: string, name: string, slug: string, organizationType: { code: string, name: string } | null, organizationMembersCollection: { edges: Array<{ node: { id: string } }> } | null } | null } }> } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const ScheduleFieldsFragmentDoc = new TypedDocumentString(`
    fragment ScheduleFields on Schedules {
  id
  name
  isActive
  timeZone
  scheduleType {
    code
  }
  scheduleTasksCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ createdAt: AscNullsLast }]
    first: 100
  ) {
    edges {
      node {
        id
        cronSchedule
        actionId
      }
    }
  }
}
    `, {"fragmentName":"ScheduleFields"}) as unknown as TypedDocumentString<ScheduleFieldsFragment, unknown>;
export const ActionFieldsFragmentDoc = new TypedDocumentString(`
    fragment ActionFields on Actions {
  id
  name
  linkToUrl
  textPhoneNumber
  actionType {
    code
  }
}
    `, {"fragmentName":"ActionFields"}) as unknown as TypedDocumentString<ActionFieldsFragment, unknown>;
export const AliasFieldsFragmentDoc = new TypedDocumentString(`
    fragment AliasFields on Aliases {
  id
  alias
  aliasType {
    code
    isUserEditable
  }
}
    `, {"fragmentName":"AliasFields"}) as unknown as TypedDocumentString<AliasFieldsFragment, unknown>;
export const DesignFieldsFragmentDoc = new TypedDocumentString(`
    fragment DesignFields on Novas {
  id
  name
  color
  qrStyle
  embeddedLink
  embeddedAliasId
  novaType {
    code
  }
  novaDecorationImage {
    imageUrl
  }
}
    `, {"fragmentName":"DesignFields"}) as unknown as TypedDocumentString<DesignFieldsFragment, unknown>;
export const QrCodeFieldsFragmentDoc = new TypedDocumentString(`
    fragment QrCodeFields on Constellations {
  id
  name
  color
  icon
  isArchived
  activeActionId
  defaultQrCodeNovaId
  defaultWebLinkNovaId
  createdAt
  updatedByUser {
    firstName
    lastName
  }
  actionsCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ createdAt: AscNullsLast }]
    first: 100
  ) {
    edges {
      node {
        ...ActionFields
      }
    }
  }
  aliasesCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...AliasFields
      }
    }
  }
  novasCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...DesignFields
      }
    }
  }
  groupConstellationLinksCollection(
    filter: { isDeleted: { eq: false } }
    first: 100
  ) {
    edges {
      node {
        groupId
      }
    }
  }
}
    fragment ActionFields on Actions {
  id
  name
  linkToUrl
  textPhoneNumber
  actionType {
    code
  }
}
fragment AliasFields on Aliases {
  id
  alias
  aliasType {
    code
    isUserEditable
  }
}
fragment DesignFields on Novas {
  id
  name
  color
  qrStyle
  embeddedLink
  embeddedAliasId
  novaType {
    code
  }
  novaDecorationImage {
    imageUrl
  }
}`, {"fragmentName":"QrCodeFields"}) as unknown as TypedDocumentString<QrCodeFieldsFragment, unknown>;
export const GroupFieldsFragmentDoc = new TypedDocumentString(`
    fragment GroupFields on Groups {
  id
  name
  color
  icon
  parentGroupId
}
    `, {"fragmentName":"GroupFields"}) as unknown as TypedDocumentString<GroupFieldsFragment, unknown>;
export const AdministratorSelfDocument = new TypedDocumentString(`
    query AdministratorSelf($userId: UUID!) {
  administratorsCollection(
    filter: { userId: { eq: $userId }, isDeleted: { eq: false } }
    first: 1
  ) {
    edges {
      node {
        id
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AdministratorSelfQuery, AdministratorSelfQueryVariables>;
export const AdminOrganizationsDocument = new TypedDocumentString(`
    query AdminOrganizations($first: Int!, $after: Cursor, $pattern: String!) {
  organizationsCollection(
    filter: {
      isDeleted: { eq: false }
      or: [{ name: { ilike: $pattern } }, { slug: { ilike: $pattern } }]
    }
    orderBy: [{ name: AscNullsFirst }]
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        name
        slug
        createdAt
        organizationType {
          name
        }
        organizationMembersCollection(filter: { isDeleted: { eq: false } }, first: 200) {
          edges {
            node {
              id
            }
          }
        }
        constellationsCollection(filter: { isDeleted: { eq: false } }, first: 500) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `) as unknown as TypedDocumentString<AdminOrganizationsQuery, AdminOrganizationsQueryVariables>;
export const AdminAppVersionsDocument = new TypedDocumentString(`
    query AdminAppVersions($first: Int!, $after: Cursor) {
  usersCollection(
    filter: { isDeleted: { eq: false }, appVersion: { is: NOT_NULL } }
    orderBy: [{ appVersionSeenAt: DescNullsLast }]
    first: $first
    after: $after
  ) {
    edges {
      node {
        id
        emailAddress
        firstName
        lastName
        appVersion
        appVersionSeenAt
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
    `) as unknown as TypedDocumentString<AdminAppVersionsQuery, AdminAppVersionsQueryVariables>;
export const ActionTypesDocument = new TypedDocumentString(`
    query ActionTypes {
  actionTypesCollection(filter: { isDeleted: { eq: false } }, first: 20) {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ActionTypesQuery, ActionTypesQueryVariables>;
export const FeedbackMessageTypesDocument = new TypedDocumentString(`
    query FeedbackMessageTypes {
  feedbackMessageTypesCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ code: AscNullsFirst }]
    first: 20
  ) {
    edges {
      node {
        id
        code
        name
        description
        color
      }
    }
  }
}
    `) as unknown as TypedDocumentString<FeedbackMessageTypesQuery, FeedbackMessageTypesQueryVariables>;
export const OrganizationMemberRolesDocument = new TypedDocumentString(`
    query OrganizationMemberRoles {
  organizationMemberRolesCollection(
    filter: { isDeleted: { eq: false } }
    first: 20
  ) {
    edges {
      node {
        id
        code
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationMemberRolesQuery, OrganizationMemberRolesQueryVariables>;
export const ScheduleTypesDocument = new TypedDocumentString(`
    query ScheduleTypes {
  scheduleTypesCollection(filter: { isDeleted: { eq: false } }, first: 20) {
    edges {
      node {
        id
        code
        name
        enabled
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ScheduleTypesQuery, ScheduleTypesQueryVariables>;
export const OrganizationMembersDocument = new TypedDocumentString(`
    query OrganizationMembers($organizationId: UUID!) {
  organizationMembersCollection(
    filter: { organizationId: { eq: $organizationId }, isDeleted: { eq: false } }
    first: 500
  ) {
    edges {
      node {
        id
        createdAt
        organizationMemberRole {
          code
        }
        user {
          id
          firstName
          lastName
          emailAddress
        }
      }
    }
  }
  organizationMemberInvitationsCollection(
    filter: {
      invitedToOrganizationId: { eq: $organizationId }
      isDeleted: { eq: false }
      declined: { eq: false }
    }
    first: 500
  ) {
    edges {
      node {
        id
        createdAt
        invitedUserEmailAddress
        organizationMemberRole {
          code
        }
        organizationMembersCollection(filter: { isDeleted: { eq: false } }, first: 1) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationMembersQuery, OrganizationMembersQueryVariables>;
export const NotificationsDocument = new TypedDocumentString(`
    query Notifications($userId: UUID!) {
  notificationsCollection(
    filter: {
      userId: { eq: $userId }
      isDeleted: { eq: false }
      or: [{ dismissed: { eq: false } }, { dismissed: { is: NULL } }]
    }
    orderBy: [{ timestamp: DescNullsLast }]
    first: 100
  ) {
    edges {
      node {
        id
        read
        dismissed
        timestamp
        createdAt
        notificationType {
          code
          name
        }
        organizationMemberInvitation {
          id
          declined
          invitedUserEmailAddress
          invitedToOrganization {
            id
            name
            slug
          }
          invitedByUser {
            firstName
            lastName
            emailAddress
          }
          organizationMemberRole {
            code
            name
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NotificationsQuery, NotificationsQueryVariables>;
export const OrganizationBySlugDocument = new TypedDocumentString(`
    query OrganizationBySlug($slug: String!) {
  organizationsCollection(
    filter: { slug: { eq: $slug }, isDeleted: { eq: false } }
    first: 1
  ) {
    edges {
      node {
        id
        name
        slug
        organizationType {
          code
          name
        }
        organizationMembersCollection(filter: { isDeleted: { eq: false } }, first: 500) {
          edges {
            node {
              id
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>;
export const OrganizationSlugsDocument = new TypedDocumentString(`
    query OrganizationSlugs($ids: [UUID!]!) {
  organizationsCollection(
    filter: { id: { in: $ids }, isDeleted: { eq: false } }
    first: 200
  ) {
    edges {
      node {
        id
        slug
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<OrganizationSlugsQuery, OrganizationSlugsQueryVariables>;
export const OrganizationQrCodesDocument = new TypedDocumentString(`
    query OrganizationQrCodes($organizationId: UUID!) {
  constellationsCollection(
    filter: { organizationId: { eq: $organizationId }, isDeleted: { eq: false } }
    orderBy: [{ createdAt: DescNullsLast }]
    first: 500
  ) {
    edges {
      node {
        ...QrCodeFields
      }
    }
    pageInfo {
      hasNextPage
    }
  }
}
    fragment ActionFields on Actions {
  id
  name
  linkToUrl
  textPhoneNumber
  actionType {
    code
  }
}
fragment AliasFields on Aliases {
  id
  alias
  aliasType {
    code
    isUserEditable
  }
}
fragment DesignFields on Novas {
  id
  name
  color
  qrStyle
  embeddedLink
  embeddedAliasId
  novaType {
    code
  }
  novaDecorationImage {
    imageUrl
  }
}
fragment QrCodeFields on Constellations {
  id
  name
  color
  icon
  isArchived
  activeActionId
  defaultQrCodeNovaId
  defaultWebLinkNovaId
  createdAt
  updatedByUser {
    firstName
    lastName
  }
  actionsCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ createdAt: AscNullsLast }]
    first: 100
  ) {
    edges {
      node {
        ...ActionFields
      }
    }
  }
  aliasesCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...AliasFields
      }
    }
  }
  novasCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...DesignFields
      }
    }
  }
  groupConstellationLinksCollection(
    filter: { isDeleted: { eq: false } }
    first: 100
  ) {
    edges {
      node {
        groupId
      }
    }
  }
}`) as unknown as TypedDocumentString<OrganizationQrCodesQuery, OrganizationQrCodesQueryVariables>;
export const OrganizationGroupsDocument = new TypedDocumentString(`
    query OrganizationGroups($organizationId: UUID!) {
  groupsCollection(
    filter: {
      organizationId: { eq: $organizationId }
      isDeleted: { eq: false }
      isArchived: { eq: false }
    }
    orderBy: [{ name: AscNullsLast }]
    first: 500
  ) {
    edges {
      node {
        ...GroupFields
      }
    }
  }
}
    fragment GroupFields on Groups {
  id
  name
  color
  icon
  parentGroupId
}`) as unknown as TypedDocumentString<OrganizationGroupsQuery, OrganizationGroupsQueryVariables>;
export const QrCodeDocument = new TypedDocumentString(`
    query QrCode($constellationId: UUID!) {
  constellationsCollection(
    filter: { id: { eq: $constellationId }, isDeleted: { eq: false } }
    first: 1
  ) {
    edges {
      node {
        ...QrCodeFields
        schedulesCollection(
          filter: { isDeleted: { eq: false } }
          orderBy: [{ createdAt: AscNullsLast }]
          first: 100
        ) {
          edges {
            node {
              ...ScheduleFields
            }
          }
        }
      }
    }
  }
}
    fragment ActionFields on Actions {
  id
  name
  linkToUrl
  textPhoneNumber
  actionType {
    code
  }
}
fragment AliasFields on Aliases {
  id
  alias
  aliasType {
    code
    isUserEditable
  }
}
fragment DesignFields on Novas {
  id
  name
  color
  qrStyle
  embeddedLink
  embeddedAliasId
  novaType {
    code
  }
  novaDecorationImage {
    imageUrl
  }
}
fragment ScheduleFields on Schedules {
  id
  name
  isActive
  timeZone
  scheduleType {
    code
  }
  scheduleTasksCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ createdAt: AscNullsLast }]
    first: 100
  ) {
    edges {
      node {
        id
        cronSchedule
        actionId
      }
    }
  }
}
fragment QrCodeFields on Constellations {
  id
  name
  color
  icon
  isArchived
  activeActionId
  defaultQrCodeNovaId
  defaultWebLinkNovaId
  createdAt
  updatedByUser {
    firstName
    lastName
  }
  actionsCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ createdAt: AscNullsLast }]
    first: 100
  ) {
    edges {
      node {
        ...ActionFields
      }
    }
  }
  aliasesCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...AliasFields
      }
    }
  }
  novasCollection(
    filter: { isDeleted: { eq: false } }
    orderBy: [{ id: AscNullsLast }]
    first: 50
  ) {
    edges {
      node {
        ...DesignFields
      }
    }
  }
  groupConstellationLinksCollection(
    filter: { isDeleted: { eq: false } }
    first: 100
  ) {
    edges {
      node {
        groupId
      }
    }
  }
}`) as unknown as TypedDocumentString<QrCodeQuery, QrCodeQueryVariables>;
export const SessionDocument = new TypedDocumentString(`
    query Session($userId: UUID!) {
  usersCollection(
    filter: { id: { eq: $userId }, isDeleted: { eq: false } }
    first: 1
  ) {
    edges {
      node {
        id
        firstName
        lastName
        emailAddress
      }
    }
  }
  organizationMembersCollection(
    filter: { userId: { eq: $userId }, isDeleted: { eq: false } }
    first: 100
  ) {
    edges {
      node {
        id
        organizationMemberRole {
          code
        }
        organization {
          id
          name
          slug
          organizationType {
            code
            name
          }
          organizationMembersCollection(filter: { isDeleted: { eq: false } }, first: 500) {
            edges {
              node {
                id
              }
            }
          }
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SessionQuery, SessionQueryVariables>;